var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8823 16.1178 72 36 72Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9394 33.5758H29.1152C31.5733 33.5758 33.5758 31.5733 33.5758 29.1152V21.9394C33.5758 20.8679 32.7079 20 31.6364 20C30.5648 20 29.697 20.8679 29.697 21.9394V29.1152C29.697 29.4352 29.4352 29.697 29.1152 29.697H21.9394C20.8679 29.697 20 30.5648 20 31.6364C20 32.7079 20.8679 33.5758 21.9394 33.5758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.3636 20C39.2921 20 38.4243 20.8679 38.4243 21.9394V29.1152C38.4243 31.5733 40.4267 33.5758 42.8849 33.5758H50.0606C51.1321 33.5758 52 32.7079 52 31.6364C52 30.5648 51.1321 29.697 50.0606 29.697H42.8849C42.5649 29.697 42.303 29.4352 42.303 29.1152V21.9394C42.303 20.8679 41.4352 20 40.3636 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.9394 42.3046H29.1152C29.4352 42.3046 29.697 42.5664 29.697 42.8864V50.0621C29.697 51.1337 30.5648 52.0015 31.6364 52.0015C32.7079 52.0015 33.5758 51.1337 33.5758 50.0621V42.8864C33.5758 40.4282 31.5733 38.4258 29.1152 38.4258H21.9394C20.8679 38.4258 20 39.2937 20 40.3652C20 41.4367 20.8679 42.3046 21.9394 42.3046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.303 50.0621V42.8864C42.303 42.5664 42.5649 42.3046 42.8849 42.3046H50.0606C51.1321 42.3046 52 41.4367 52 40.3652C52 39.2937 51.1321 38.4258 50.0606 38.4258H42.8849C40.4267 38.4258 38.4243 40.4282 38.4243 42.8864V50.0621C38.4243 51.1337 39.2921 52.0015 40.3636 52.0015C41.4352 52.0015 42.303 51.1337 42.303 50.0621Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.fd192388eb3dfbe9922c9ba8fcb34bb7.svg";
export { ForwardRef as ReactComponent };